<script>
  import { mergeData } from "vue-functional-data-merge";
  
  export default {
    functional: true,
    name: "RightSideBar",
    props: {
      size: {
        type: String,
        default: "sm"
      },
      show: {
        type: Boolean,
        default: false,
      },
    },
    render(h, { props, data, children }) {
      return h(
        "div",
        mergeData(data, {
          staticClass: "right-side-bar",
          class: {
            sm: props.size === "sm" ? true : false,
            md: props.size === "md" ? true : false,
            lg: props.size === "lg" ? true : false,
            xl: props.size === "xl" ? true : false,
            full: props.size === "full" ? true : false,
            hide: props.show === null ? false : !props.show,
            show: props.show === null ? false : props.show,
          },
        }),
        children
      );
    },
  };
</script>
